module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iter-step.js
// module id = 64
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_iter-step.js